import React from 'react';
import '../../styles/mfw.scss';
import { Link } from 'react-router-dom';



function Mfwfebruary() {

const image1= '/images/MFW2024/MaddalenaAnteprima.jpg';
const image2= '/images/MFW2024/MeganRiaAnteprima.jpg';
const image3= '/images/MFW2024/MeganRiaPloom.jpg';
const image4= '/images/MFW2024/MeganRiaFiorucci.jpg';
const image5= '/images/MFW2024/MeganRiaSaraWong.jpg';
const image6= '/images/MFW2024/MaddalenaSaraWong.jpg';
const image7= '/images/MFW2024/MaddalenaRichmond.jpg';
const image8= '/images/MFW2024/MeganPhilipp.jpg';
const image9= '/images/MFW2024/MeganFranchi.jpg';
const image10= '/images/MFW2024/MeganRichmond.jpg';
const image11= '/images/MFW2024/MeganANIYE.jpg';
const image12= '/images/MFW2024/MeganAVAVAV.jpg';
const image13= '/images/MFW2024/MaddalenaPloom.jpg';
const image14= '/images/MFW2024/NicholasDHRUV.jpg';
const image15= '/images/MFW2024/MeganDHRUV.jpg';
const image16= '/images/MFW2024/MeganBridgertone.jpg';
const image17= '/images/MFW2024/MeganYSL.jpg';
const image18= '/images/MFW2024/CamillaFendi.jpeg';
const image19= '/images/MFW2024/MeganIceberg.jpg';
const image20= '/images/MFW2024/MeganMoschino.PNG';
const image21= '/images/MFW2024/MeganANIYERED.jpg';
const image22= '/images/MFW2024/NicholasRabanne.jpg';
const image23= '/images/MFW2024/SamueleSprayground.PNG';

const immagini = [
{ image: image13, title: ["Maddalena Svevi x Ploom Event"], className: ""  },
{ image: image1, title: ["Maddalena Svevi x Anteprima" ,"Fashion Show"], className: "" },
{ image: image2, title: ["Megan Ria x Anteprima " ,"Fashion Show"], className: "" },
{ image: image3, title: ["Megan Ria x Ploom Event"], className: ""  },
{ image: image4, title: ["Megan Ria x Fiorucci Event"], className: ""  },
{ image: image5, title: ["Megan Ria x Sara Wong ","Fashion Show"], className: "" },
{ image: image6, title: ["Maddalena Svevi x Sara Wong ","Fashion Show"], className: "" },
{ image: image7, title: ["Maddalena Svevi x Richmond Event"], className: ""  },
{ image: image8, title: ["Megan Ria x Philippe Plein","Fashion Show"], className: ""  },
{ image: image9, title: ["Megan Ria x Elisabetta Franchi","Fashion Show"], className: "" },
{ image: image10, title: ["Megan Ria x Richmond Event"], className: "" },
{ image: image11, title: ["Megan Ria x ANIYE","Fashion Show"], className: ""  },
{ image: image12, title: ["Megan Ria x AVAVAV","Fashion Show"], className: ""  },
{ image: image14, title: ["Nicholas Borgogni x Dhruv Kapoor","Fashion Show"], className: "" },
{ image: image15, title: ["Megan Ria x Dhruv Kapoor", "Fashion Show"], className: "" },
{ image: image16, title: [ "Megan Ria x Bridgerton Event in " ,"London"], className: "" },
{ image: image17, title: ["Megan Ria x Yves Saint Laurent Event"], className: ""},
{ image: image18, title: ["Camilla Clemente x Fendi","Fashion Show"], className: ""},
{ image: image19, title: ["Megan Ria x Iceberg","Fashion Show"], className: ""},
{ image: image20, title: ["Megan Ria x Moschino","Fashion Show"], className: ""},
{ image: image21, title: ["Megan Ria x Aniye Records","Fashion Show"], className: ""},
{ image: image22, title: ["Nicholas Borgogni x Rabanne"], className: ""},
{ image: image23, title: ["Samuele Maragliano x Sprayground","Fashion Show"], className: ""},

];
return (
<section className="magazine">
  <div className="image-grid">
    {immagini.map((img, index) => (
      <div key={index} className={`image-grid__item ${img.className}`}>
        <Link to={img.link}>
          <img src={img.image} alt={img.title.join(' ')} />
          <h3 className="image-grid__title">
            {img.title.map((line, i) => (
              <span key={i}>
                {line}
                {i < img.title.length - 1 && <br />}
              </span>
            ))}
          </h3>
        </Link>
      </div>
    ))}
  </div>
</section>
);
}

export default Mfwfebruary;
